import React, { useContext } from 'react';

/**
 * @typedef {{ req: object, res: object, store: object }} ServerSideExecuteArgs
 */

/**
 * Context for collecting server-side execute functions during render.
 * Value is an array of run callbacks when collecting, null otherwise.
 */
export const ServerSideExecuteContext = React.createContext(null);

/**
 * Hook for function components to register a server-side execute loader.
 * When inside a collecting render (runServerSideExecutes), registers the run
 * callback to be executed with { req, res, store }. Outside collecting renders,
 * this is a no-op.
 *
 * @param {(args: ServerSideExecuteArgs) => Promise<void>|void} run - The loader function to execute
 */
export function useServerSideExecute(run) {
  const collector = useContext(ServerSideExecuteContext);
  if (collector !== null) {
    collector.push(run);
  }
}

/**
 * Registers a server-side execute loader for class components.
 * Call from render() with this.context (set static contextType = ServerSideExecuteContext).
 *
 * @param {Array|null} collector - The collector from context, may be null
 * @param {(args: ServerSideExecuteArgs) => Promise<void>|void} run - The loader function to execute
 */
export function registerServerSideExecute(collector, run) {
  if (collector !== null) {
    collector.push(run);
  }
}
